import Repository from './Repository'
import TokenService from '../helpers/token'

const resource = `${Repository.defaults.baseURL}/school-levels`
const baseURL  = `${Repository.defaults.baseURL}`

export default {
    async listSchoolApi(attrs,params) {
        const response = await Repository.get(`${baseURL}/fg/list?obj=core_school${attrs}`, {
            params,
            headers: TokenService.getHeader()
        })
        return response
    },
    async updateContactSchoolApi(id, data) {
        const response = await Repository.put(`${baseURL}/customer/${id}/schools`, data, {
            headers: TokenService.getHeader(),
        })
        return response
    }
}
